export default "__VITE_ASSET__DHiPx52m__"